import React, { useContext, useEffect, useState } from 'react';
import Uploadvideo from '../Gallery/UploadVideo';
import { Context } from "../contexts/AppContext";
import ProgressBar from './ProgressBar';
import { postData } from "../../lib/utils";
import VideoThumbnail from './VideoThumbnail';
import StudioHeader from './StudioHeader';
import VideoHeader from '../PropertyList/VideoHeader';

function StudioManager() {
  const { value, progress } = useContext(Context);
  const [appState, setAppState] = value;
  const { currentFolderName, currentGalleryName, currentGalleryId, currentDBGalleryId } = appState;

  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const { files = [], startProgress, updateProgress, stopProgress } = progress;

  const [fileName, setFileName] = useState("");
  const [prgBarVal, setPrgVal] = useState(0);
  const [showPrgComp, setShowPrgComp] = useState(false);
  const [dataLoad, setDataLoaded] = useState(false);

  const videoLen = appState?.videoArr?.length || 0;

  useEffect(() => {
    setModalOpen(appState.modalData);
  }, [appState.modalData]);

  useEffect(() => {
    // Mark data loaded once videoArr is available
    if (appState.videoArr) {
      setDataLoaded(true);
    }
  }, [appState.videoArr]);

  const showProgressBar = (fileName, value) => {
    startProgress(fileName);
    updateProgress(value);
  };

  const videoUploadedDone = async (fileName) => {
    const response = await postData("videos/createVideo", {
      title: fileName.name.split(".")[0],
      url: `${appState.currentFolderData.name}/${currentGalleryName}/${fileName.name}`,
      galleryId: appState.currentGalleryData._id
    });

    if (response) {
      setAppState((prevState) => ({
        ...prevState,
        videoArr: [...prevState.videoArr, response],
      }));

      setShowPrgComp(false);
      stopProgress();
    }
  };

  return (
    <div>
      <VideoHeader />

      {!dataLoad ? (
        <div className="absolute h-screen flex flex-col justify-center mx-auto w-full items-center border">
          <h2 className="p-4 font-bold">Loading videos...</h2>
        </div>
      ) : (
        <>
          {files.length <= 0 && videoLen <= 0 && (
            <div className="absolute h-screen flex flex-col justify-center mx-auto w-full items-center border">
              <h2 className="p-4 font-bold">No Videos added yet</h2>
              <Uploadvideo showProgressBar={showProgressBar} videoUploadedDone={videoUploadedDone} />
            </div>
          )}

          {showPrgComp && (
            <ProgressBar id="prgbar" fileName={fileName} prgBarVal={prgBarVal} />
          )}

          {!showPrgComp && videoLen > 0 && (
            <VideoThumbnail />
          )}
        </>
      )}
    </div>
  );
}

export default StudioManager;
